import { Box, Typography } from "@mui/material"
import { styled } from "@mui/system"

const StyledTypography = styled(Typography)(({theme}) => ({
  padding: "0 0 0.6em 0",
  color: theme.palette.secondary.main
}))

/**
 * 
 * @param {object} props E.g. {label, text, boldValue [true|false], boxSx, fieldSx } 
 * @returns JSX
 * This is a slightly improved version of SmallLabelledText in Hiko. Good candidate for np-react-utls library.
 */
export function SmallLabelledText({label = '', text, boldValue = true, boxSx={}, fieldSx={}}) {
    return (
        text
        ?
        <Box sx={boxSx}>
            <Box>
                <small>
                    <em>{label}</em>
                </small>
            </Box>
            <Box>
                <StyledTypography sx={fieldSx} variant="body1">
                    {
                    boldValue ? <strong>{text}</strong> : <span>{text}</span>
                    } 
                </StyledTypography>
            </Box>
        </Box>
        :
        null
    )
}